import * as go from 'gojs';
import theme from 'theme/theme';
import plusImage from './plus.png';
import hammerAndBoomImage from 'unitData/Breaker/breaker.png';
import type { GyratoryCrusherNodeData, JawCrusherNodeData } from 'gojs/types';

const $ = go.GraphObject.make;

const WIDTH = 42;
const HEIGHT = 48;

type AtdUnitNodeData = JawCrusherNodeData | GyratoryCrusherNodeData;

export const attachmentToolPanel = () =>
  $(
    go.Panel,
    'Spot',
    {
      alignment: go.Spot.TopRight,
      alignmentFocus: go.Spot.TopRight,
    },
    new go.Binding(
      'visible',
      '',
      (data: AtdUnitNodeData) => !!data?.attachmentTool?.enabled,
    ),
    $(
      go.Shape,
      'RoundedRectangle',
      {
        desiredSize: new go.Size(WIDTH, HEIGHT),
        opacity: 0.8,
        fill: null,
      },
      new go.Binding(
        'stroke',
        'selected',
        (selected: AtdUnitNodeData['selected']) =>
          selected ? theme.palette.primary.main : 'transparent',
      ),
      new go.Binding(
        'fill',
        'selected',
        (selected: AtdUnitNodeData['selected']) =>
          selected ? theme.palette.info.light : 'transparent',
      ),
    ),
    $(go.Picture, {
      source: hammerAndBoomImage,
      desiredSize: new go.Size(WIDTH, HEIGHT - 12),
      flip: go.GraphObject.FlipHorizontal,
      alignment: go.Spot.Bottom,
      alignmentFocus: new go.Spot(go.Spot.Bottom.x, go.Spot.Bottom.y, 0, 5),
    }),
    $(go.Picture, {
      source: plusImage,
      desiredSize: new go.Size(12, 8),
      alignment: go.Spot.TopLeft,
      alignmentFocus: go.Spot.TopLeft,
    }),
  );
